<template>
  <v-dialog
    v-model="edituser"
    max-width="600px">
    <EditUserModal
      v-if="edituser"
      :current_user="current_user"
      :edit_user="edituser"
      v-on:close="
        edituser = false;
        getUsers();
      " />
  </v-dialog>
  <v-dialog
    v-model="createuser"
    max-width="600px">
    <CreateNewUserModal
      v-if="createuser"
      v-on:close="
        createuser = false;
        getUsers();
      " />
  </v-dialog>
  <v-dialog
    v-model="deleteuser"
    max-width="600px">
    <DeleteUserModal
      v-if="deleteuser"
      :current_user="current_user"
      v-on:close="
        deleteuser = false;
        getUsers();
      "
      :delete_user="deleteuser" />
  </v-dialog>
  <div style="display: flex">
    <div style="font-weight: bold; font-size: 20px">
      <v-icon class="mr-3">mdi-account-group</v-icon>
      Users
    </div>
    <v-spacer />
    <HelpButton mdx-name="UserConfigure" />
  </div>
  <v-divider class="mt-3" />
  <div class="config-page-body">
    <div style="margin-top: 40px; margin-bottom: 20px">
      <div></div>
      <v-card-subtitle>User list</v-card-subtitle>
      <v-divider />
    </div>
    <div
      style="
        background: var(--v-backgroundColor-base);
        max-height: 400px;
        padding: 0px;
        border-radius: 4px;
        overflow: auto;
        display: flex;
        flex-direction: column;
      ">
      <v-card
        class="mb-2 d-flex align-center"
        style="height: 120px; flex: 1 0 auto"
        flat
        v-for="(user, i) in users"
        :key="(user, i)">
        <div class="mx-5">
          <v-icon
            style="font-size: 65px !important"
            x-large>
            mdi-account
          </v-icon>
        </div>
        <div>
          <v-card-title style="display: flex; align-items: center">
            <v-tooltip
              location="top"
              :text="`${deluge.roles[user.role].description}`">
              <template v-slot:activator="{ props }">
                <v-icon
                  v-bind="props"
                  class="mr-2"
                  size="small">
                  {{ deluge.roles[user.role].icon }}
                </v-icon>
              </template>
            </v-tooltip>
            <v-tooltip
              location="top"
              :text="`'${user.username}' has not accepted their EULA yet`">
              <template v-slot:activator="{ props }">
                <v-icon
                  v-bind="props"
                  v-if="!user.eula_accepted"
                  class="mr-2"
                  size="small"
                  color="orange">
                  mdi-alert
                </v-icon>
              </template>
            </v-tooltip>
            {{ user.username }}
          </v-card-title>
          <v-card-subtitle>ID #{{ user.id }}</v-card-subtitle>
          <v-card-actions>
            <v-btn
              :disabled="user.username === 'admin'"
              @click="EditUser(user)"
              small
              variant="outlined"
              color="warning">
              Edit
            </v-btn>
            <v-btn
              :disabled="user.username === 'admin'"
              @click="DeleteUser(user)"
              small
              variant="outlined"
              color="red">
              Delete
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </div>
    <v-divider
      class="mt-3"
      style="margin-bottom: 12px" />
    <div style="display: flex">
      <v-spacer />
      <v-btn
        color="primary"
        variant="flat"
        class=""
        prepend-icon="mdi-account-plus"
        @click="createuser = true">
        Add User
      </v-btn>
    </div>
  </div>
</template>
<script setup>
import EditUserModal from './EditUserModal.vue';
import DeleteUserModal from './DeleteUserModal.vue';
import CreateNewUserModal from './CreateNewUserModal.vue';
import { ref, onMounted, onBeforeMount, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { deluge } from '@/stores/deluge.js';
import HelpButton from '../Help-Hints/HelpButton.vue';
import { $http } from '../../stores/http.js';

const router = useRouter();
const route = useRoute();
const deleteuser = ref(false);
const edituser = ref(false);
const createuser = ref(false);
const current_user = ref(undefined);
const users = ref([]);
const headers = ref([
  {
    text: 'ID',
    align: 'start',
    value: 'id',
  },
  { text: 'Username', value: 'username' },
  { text: 'Email', value: 'email' },
  { text: 'Access Counter', value: 'access_counter' },
]);

onMounted(() => {
  current_user.value = localStorage.getItem('username');
  getUsers();
});
function DeleteUser(user) {
  current_user.value = user;
  deleteuser.value = true;
}
function EditUser(user) {
  current_user.value = user;
  edituser.value = true;
}
function getUsers() {
  $http('GET', '/users').then((response) => {
    users.value = JSON.parse(response);
    deleteuser.value = false;
    edituser.value = false;
    createuser.value = false;
  });
}
</script>
<style scoped>
@import './config.css';
</style>
